import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE =
  "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/score-card";
const API_KEY = "G8js92h02h3j0s0sk2jhsj392slk20s";


export const fetchScoreCards = createAsyncThunk(
  "scoreCard/fetchScoreCards",
  async ({ buyerId, supplierId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE}?page=${page}&limit=${limit}&supplierId=${supplierId}&buyerId=${buyerId}`,
        { headers: { "x-api-key": API_KEY, accept: "application/json" } }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createScoreCard = createAsyncThunk(
  "scoreCard/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await fetch(
        "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/score-card",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData);
      }

      return await res.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);



// UPDATE score card
export const updateScoreCard = createAsyncThunk(
  "scoreCard/updateScoreCard",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_BASE}/${id}/update`, data, {
        headers: {
          "x-api-key": API_KEY,
          "Content-Type": "application/json",
          accept: "application/json",
        },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// DELETE score card
export const deleteScoreCard = createAsyncThunk(
  "scoreCard/deleteScoreCard",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_BASE}/${id}`, {
        headers: { "x-api-key": API_KEY, accept: "application/json" },
      });
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const scoreCardSlice = createSlice({
  name: "scoreCard",
  initialState: {
    cards: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET
      .addCase(fetchScoreCards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchScoreCards.fulfilled, (state, action) => {
        state.loading = false;
        state.cards = action.payload?.data || [];
      })
      .addCase(fetchScoreCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // CREATE
      .addCase(createScoreCard.fulfilled, (state, action) => {
        state.cards.push(action.payload);
      })
      // UPDATE
      .addCase(updateScoreCard.fulfilled, (state, action) => {
        const updated = action.payload;
        state.cards = state.cards.map((c) =>
          c.scoreCardId === updated.scoreCardId ? updated : c
        );
      })
      // DELETE
      .addCase(deleteScoreCard.fulfilled, (state, action) => {
        state.cards = state.cards.filter((c) => c.scoreCardId !== action.payload);
      });
  },
});

export default scoreCardSlice.reducer;
